// TODO: refactor this into a hook!
export const getLastSegment = (path) => {
  if(path === "/") return path;
  return path.substring(path.lastIndexOf("/") + 1)
}


export const getCurrentPageIndex = (formPageSlugs, currentSlug) => {
  return formPageSlugs.indexOf(currentSlug)+1;
}